export default "__VITE_ASSET__7u0uWvCF__"